module.exports = __webpack_public_path__ + "static/media/login-icon.2ede9910.svg";